export const AllDriversPackage = '@automata-tech/ALL';

export const AllDriversLatestVersion = 'latest';
